import gql from 'graphql-tag';

export default gql`
  mutation removeMediaFromLibraryMutation($libraryItem: LibraryItemInput!) {
    removeMediaFromLibrary(libraryItem: $libraryItem)
  }
`;
